/*
 * @Author: bbqin
 * @Date: 2022-10-18 10:12:08
 * @LastEditTime: 2022-10-26 11:13:34
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import useMetaFieldSetting from './store';
import { BaseComponent } from '@platform/template';
import { getMultiLang } from '@platform/api';
import SettingPanel from "./setting";

import sideBox from './sideBox';

require('./index.less');

const Setting = sideBox(SettingPanel);

const defaultProps = {
    prefixCls: 'field-setting',
    name: 'MetaFieldSetting',
};

/**
 * 创建元数据字段设置组件
 * @memberof MetaFieldSetting
 * @component createMetaFieldSetting
 * @property {string} sideBox - 侧边的属性
 * @property {boolean} [uncontrolledVisible=false] - 不可控制组件的显隐性
 * @property {function(): null} onSave - 保存按钮回调
 * @property {function(): null} onReset - 重置按钮回调
 * @property {function(): null} onHide - 侧边隐藏回调
 */

class MetaFieldSetting extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, id, ...others } = props;
        const oldConfig = store.getStore('config');
        // 设置初始参数
        store.setStore('config', { ...oldConfig, id, ...others }, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { store, ...others } = nextProps;
    }

    UNSAFE_componentWillMount() {
        const { store } = this.props;
        let callback = (json, bool) => {
            if (bool) {
                // 缓存多语
                store.setStore('langJson', json);
            }
        };
        getMultiLang({ moduleId: 'page_meta_setting', callback });
    }

    render() {
        const { sideBox = {} } = this.props;
        return sideBox ? <Setting {...this.props} /> : <SettingPanel {...this.props} />;
    }
}

MetaFieldSetting.defaultProps = defaultProps;
MetaFieldSetting.displayName = 'MetaFieldSetting';
MetaFieldSetting.useMetaFieldSetting = useMetaFieldSetting;

export default MetaFieldSetting;